<template>
    <div>
        <fieldset :disabled="loading" aria-autocomplete="no">
            <div v-if="alertVisible">
                <div class="alert alert-warning">
                    <p>
                        {{translate('warnings.imzalayiciOldVersion')}}
                    </p>
                    <div class="downloadButtons">
                        <a class="btn btn-link mt-3 downloadButton" href="https://imzalayici.com/releases/latest/imzalayici-winx64.msi"
                            target="_blank"> <span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 20 20" version="1.1">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Dribbble-Light-Preview" transform="translate(-60.000000, -7439.000000)" fill="#007bff">
                                            <g id="icons" transform="translate(56.000000, 160.000000)">
                                                <path d="M13.1458647,7289.43426 C13.1508772,7291.43316 13.1568922,7294.82929 13.1619048,7297.46884 C16.7759398,7297.95757 20.3899749,7298.4613 23.997995,7299 C23.997995,7295.84873 24.002005,7292.71146 23.997995,7289.71311 C20.3809524,7289.71311 16.7649123,7289.43426 13.1458647,7289.43426 M4,7289.43526 L4,7296.22153 C6.72581454,7296.58933 9.45162907,7296.94113 12.1724311,7297.34291 C12.1774436,7294.71736 12.1704261,7292.0908 12.1704261,7289.46524 C9.44661654,7289.47024 6.72380952,7289.42627 4,7289.43526 M4,7281.84344 L4,7288.61071 C6.72581454,7288.61771 9.45162907,7288.57673 12.1774436,7288.57973 C12.1754386,7285.96017 12.1754386,7283.34361 12.1724311,7280.72405 C9.44461153,7281.06486 6.71679198,7281.42567 4,7281.84344 M24,7288.47179 C20.3879699,7288.48578 16.7759398,7288.54075 13.1619048,7288.55175 C13.1598997,7285.88921 13.1598997,7283.22967 13.1619048,7280.56914 C16.7689223,7280.01844 20.3839599,7279.50072 23.997995,7279 C24,7282.15826 23.997995,7285.31353 24,7288.47179" id="windows-[#174]"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </span> {{translate('downloadForWindows')}}</a>
                            <a class="btn btn-link mt-3 downloadButton" href="https://imzalayici.com/releases/latest/imzalayici-osx.pkg"
                            target="_blank"> <span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 20 20" version="1.1">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Dribbble-Light-Preview" transform="translate(-102.000000, -7439.000000)" fill="#007bff">
                                            <g id="icons" transform="translate(56.000000, 160.000000)">
                                                <path d="M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485" id="apple-[#173]"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </span>
                            {{translate('downloadForMacos')}}
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="InitData == null" class="checking">
                {{translate('auditing')}}
            </div>
            <div v-else-if="InitData.Code === 0">
                <div v-if="SelectedCert == null">
                    <button type="button" @click="refreshTerminalsAndCertificates(false)"
                        class="btn btn-info btn-sm float-right" title="Listeyi yenile">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-repeat" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                            <path fill-rule="evenodd"
                                d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg>
                    </button>
                    <p>{{translate('imzalayici.selectCert')}}</p>
                    <div class="cert-list form-control">
                        <div v-if="!Terminals || Terminals.length == 0" class="text-center text-muted" style="padding:30px">
                            <p>{{translate('imzalayici.deviceCantFound')}}</p>
                            <button type="button" class="btn btn-outline-primary btn-sm"
                                @click="refreshTerminalsAndCertificates">{{translate('tryAgain')}}</button>
                        </div>
                        <div v-for="t in Terminals" v-bind:key="t.Index">
                            <div class="terminal"><b>[{{ t.Index }}] {{ t.Name }}</b> {{ t.LibName }}</div>
                            <certificate-item :cert="c" v-on:click="selectCert(c)" v-for="c in t.SignatureCertificates"
                                :key="c.CertificateSerialNumber" :loading="loading" />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <slot></slot>

                    <certificate-item :cert="SelectedCert" v-if="!loading"
                        @click="SelectedCert = null; refreshTerminalsAndCertificates(false)"
                        :title="translate('imzalayici.clickToSelectDifferentCert')" />
                    <certificate-item :cert="SelectedCert" v-else style="cursor:default;" />

                    <div class="form-group">
                        <label>{{translate('imzalayici.eSignaturePassword')}}</label>
                        <input v-model="PIN" id="pin" ref="pin" :name="autoCompleteId"
                            @focus="passwordInputType = 'password'" :type="passwordInputType" :autocomplete="autoCompleteId"
                            class="form-control" required onpaste="return false;" oncopy="return false;"
                            autofill="return false;" />
                    </div>

                    <div class="item-list" v-if="showFileList">
                        <table class="table table-borderless table-hover">
                            <tbody>
                                <tr v-for="i in items" :key="i.Id">
                                    <td>
                                        {{ i.FileName }} <small class="text-muted">{{ i.Size | prettyBytes }}</small>
                                        <div v-if="!i.OK && i.ModelState" class="text-muted" style="font-size:0.7rem;">
                                            <div v-for="errList in i.ModelState" :key="errList">
                                                <div v-for="e in errList" :key="e">{{ e }}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="width:150px;">
                                        <div v-if="i.State == signStatus.prepearing">
                                            <spinner :sr="translate('preparing')" />
                                            {{translate('preparing')}}
                                        </div>
                                        <div v-else-if="i.State == signStatus.signing">
                                            <spinner :sr="translate('signing')" />
                                            {{translate('signing')}}
                                        </div>
                                        <div v-else-if="i.State == signStatus.sending">
                                            <spinner :sr="translate('sending')" />
                                            {{translate('sending')}}
                                        </div>
                                        <div v-else-if="i.State == signStatus.completed">
                                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="text-success bi bi-check" viewBox="0 0 16 16">
                                                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                                            </svg> -->
                                            <icon-check class="text-success" />
                                            {{translate('dashboard.completed')}}
                                        </div>
                                        <div v-else-if="i.State == signStatus.canceled">
                                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="text-warning bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                            </svg> -->
                                            <icon-exclamation-triangle class="text-warning" />
                                            {{translate('finalizerStates.cancelled')}}
                                        </div>
                                        <div v-else-if="i.State == signStatus.error">
                                            <icon-exclamation-octagon class="text-danger" />
                                            {{translate('imzalayici.error')}}
                                        </div>
                                        <div v-else>{{ i.State }}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-danger" v-show="this.error">{{ this.error }}</div>
                    <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
                        <spinner />
                        {{ processingMessage }}
                    </div>
                </div>
            </div>
            <div v-else class="text-center" style="padding-top:30px;">
                <div style="padding:30px 0px;">{{translate('imzalayici.imzalayiciCantFound')}}</div>
                <div>
                    <button type="button" class="btn btn-primary" @click="check">{{translate('tryAgain')}}</button>
                    <div class="downloadButtons">
                        <a class="btn btn-link mt-3 downloadButton" href="https://www.izometri.com.tr/imzalayici/imzalayiciSetup.exe"
                            target="_blank"> <span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 20 20" version="1.1">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Dribbble-Light-Preview" transform="translate(-60.000000, -7439.000000)" fill="#007bff">
                                            <g id="icons" transform="translate(56.000000, 160.000000)">
                                                <path d="M13.1458647,7289.43426 C13.1508772,7291.43316 13.1568922,7294.82929 13.1619048,7297.46884 C16.7759398,7297.95757 20.3899749,7298.4613 23.997995,7299 C23.997995,7295.84873 24.002005,7292.71146 23.997995,7289.71311 C20.3809524,7289.71311 16.7649123,7289.43426 13.1458647,7289.43426 M4,7289.43526 L4,7296.22153 C6.72581454,7296.58933 9.45162907,7296.94113 12.1724311,7297.34291 C12.1774436,7294.71736 12.1704261,7292.0908 12.1704261,7289.46524 C9.44661654,7289.47024 6.72380952,7289.42627 4,7289.43526 M4,7281.84344 L4,7288.61071 C6.72581454,7288.61771 9.45162907,7288.57673 12.1774436,7288.57973 C12.1754386,7285.96017 12.1754386,7283.34361 12.1724311,7280.72405 C9.44461153,7281.06486 6.71679198,7281.42567 4,7281.84344 M24,7288.47179 C20.3879699,7288.48578 16.7759398,7288.54075 13.1619048,7288.55175 C13.1598997,7285.88921 13.1598997,7283.22967 13.1619048,7280.56914 C16.7689223,7280.01844 20.3839599,7279.50072 23.997995,7279 C24,7282.15826 23.997995,7285.31353 24,7288.47179" id="windows-[#174]"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </span> {{translate('downloadForWindows')}}</a>
                            <a class="btn btn-link mt-3 downloadButton" href="https://imzalayici.com/releases/latest/imzalayici-osx.pkg"
                            target="_blank"> <span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 20 20" version="1.1">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Dribbble-Light-Preview" transform="translate(-102.000000, -7439.000000)" fill="#007bff">
                                            <g id="icons" transform="translate(56.000000, 160.000000)">
                                                <path d="M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485" id="apple-[#173]"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </span>
                            {{translate('downloadForMacos')}}
                        </a>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</template>


<script>
import axios from 'axios'
import CertificateItem from '@/components/CertificateItem.vue'
import spinner from '@/components/Spinner.vue'
import iconCheck from '@/components/Icons/check.svg'
import iconExclamationOctagon from '@/components/Icons/exclamation-octagon.svg'
import iconExclamationTriangle from '@/components/Icons/exclamation-triangle.svg'

const signStatus = {
    prepearing: 'prepearing',
    signing: 'signing',
    sending: 'sending',
    completed: 'completed',
    canceled: 'canceled',
    error: 'error'
};

export default {
    name: 'ImzalayiciV1',
    props: {
        autoSubmit: {
            type: Boolean,
            default: true
        },
        items: Array,   // İmzalanacak dosyalar
        identityNumber: String,  // İmzalayacak kişinin sertifikadaki kimlik numarası
        processingMessage: null, // İşlem yapılıyor, lütfen bekleyin mesajı. Dosyaların imzalanması tamamlandıktan sonra sunucuya gönderilirken gösterilmek üzere...
        showFileList: {
            default: true,
            type: Boolean
        },
        userCertificateUrl: {
            type: String,
            default: '/user/setUserCertificate'
        },
        InitData:Object
    },
    components: {
        CertificateItem,
        spinner,
        iconCheck,
        iconExclamationOctagon,
        iconExclamationTriangle
    },
    computed: {
        autoCompleteId(){
            return "off_" + Math.random().toString().replace('.', '');
        },
        alertVisible(){
            return window.settings.imzalayiciAlertVisible
        }
    },
    created() {
        this.oldLicence = window.settings.licenceOld;// process.env.VUE_APP_IMZALAYICI_LICENCE;
        this.refreshTerminalsAndCertificates(true);
    },
    data() {
        return {
            signStatus: signStatus,
            Terminals: null,
            SelectedCert : null,
            PIN: null,
            passwordInputType : "text",
            base64certificate: null,
            loading: false,
            canceled: false,
            error: null,
            currentDocumentIndex: 0,    // Şu anda imzalanan doküman index numarası
            oldLicence: null, // 'mqv3r4B5wf4K66iNYwCcxszUwXOyc/MTWTGVOo4WoWa5qqyK1BCKAe8Iwf6P2EvyALHCmrTl1QM7bMEjI2sjXQ=='
            isImzalayiciV2: false,
            timer: null,
            lastInputTime: Date.now(),
        };
    },
    watch: {
        SelectedCert: function(val){
            if(val) {
                this.$emit('modechange', 'sign');
            } else {
                this.$emit('modechange', 'selectcert');
            }
        },
        PIN(newValue) {
            if(!this.loading){
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    if (newValue === this.PIN) {
                    this.PIN = '';
                }
                }, 30000);
            }
        },
        loading(newValue) {
            if(this.PIN != null || this.PIN != ''){
                if (newValue) {
                    // Input field is disabled
                    clearTimeout(this.timer);
                } else {
                    // Input field is enabled
                    const timeRemaining = this.getRemainingTime();
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                    if (this.PIN) {
                        this.PIN = '';
                    }
                    }, Math.max(0, 30000 - timeRemaining));
                    this.lastInputTime = Date.now();
                }
            }
        }
    },
    destroyed() {
        clearTimeout(this.timer);
    },
    methods: {
        getRemainingTime() {
            if (this.loading) {
                return 0;
            } else {
                const timeElapsed = Date.now() - this.lastInputTime;
                return Math.max(0, Math.min(timeElapsed, 30000));
            }
        },
        setLoading(isLoading){
            this.loading = isLoading;
            this.$emit('onloading', isLoading);
        },
        cancel(){
            this.canceled = true;
            this.setLoading(false);
        },
        refreshTerminalsAndCertificates(autoSelect = false){  // e-İmza terminalleri ve sertifikaları çek
            this.setLoading(true);
            
            var formData = new FormData();
            formData.set('licence', this.oldLicence);

            axios({
                method: 'post',
                url: `https://imzalayici.imzalayici.com/terminalsandcertificates`,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data' }
                })
            .then(r => {
                this.Terminals = r.data.Terminals;
                //var certList = this.Terminals.flatmap(a => a.SignatureCertificates).filter(x => !x.IsExpired);
                var certList = this.Terminals.map(x => x.SignatureCertificates).reduce((a, b) => a.concat(b)).filter(x => !x.IsExpired);

                if(this.identityNumber)
                    certList = certList.filter(x => x.Serial == this.identityNumber);

                if(certList.length == 1 && autoSelect)
                    this.selectCert(certList[0]);
                else
                    this.setLoading(false);
            })
            .catch(e => { 
                this.Terminals = null;
                console.log(e);
                this.setLoading(false);
            });
        },
        sendCert(base64cert) {    // Sertifikayı sunucuya post et

            return axios.post(this.userCertificateUrl, { Base64Certificate: base64cert })
                .then(response => {                    
                    if(!response.data.Success) {
                        console.log(response);
                        this.base64certificate = null;
                        this.SelectedCert = null;
                        alert(this.translate('errors.signatureCertCantSend') + response.data.ErrorMessages);
                    }
                })
                .catch(response => {
                    //handle error
                    this.base64certificate = null;
                    this.SelectedCert = null;
                    console.log(response);
                    window.processErrorResponse(response);
                    this.setLoading(false);
                    this.$emit('modechange', 'selectcert');
                    //alert('İmza sertifikası gönderilemedi.');
                })
                .then(() => {
                    console.info('İmza sertifikası başarıyla gönderildi.');
                    this.setLoading(false);
                });
        },
        selectCert(cert) {  // Sertifika seç
            this.setLoading(true);
            this.PIN = null;

            if(this.identityNumber && cert.Serial != this.identityNumber) {
                // alert('Seçtiğiniz sertifika oturumu açık kullanıcıya ait değil.');
                 if(confirm(this.translate('errors.editIdentity'))) {
                    this.$router.push({ name:'UserIdentity', params: { id: this.$root.$data.login.User.Id } });
                }
                this.setLoading(false);
                return;
            }

            var formData = new FormData();
            formData.set('terminal', cert.SlotId);
            formData.set('certificateNumber', cert.CertificateSerialNumber);
            formData.set('responseType', 'json');
            formData.set('licence', this.oldLicence);

            return axios({
                method: 'post',
                url: `https://imzalayici.imzalayici.com/x509certificate`,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data' }
                })
                .then(response => {                    
                    if(response.data.Code == 0) {
                        this.base64certificate = response.data.Data;
                        this.SelectedCert = cert;
                        this.sendCert(this.base64certificate);
                    } else {
                        console.log(response);
                        this.base64certificate = null;
                        this.SelectedCert = null;
                        this.setLoading(false);
                        alert(this.translate('errors.signatureCertCantReceive'));
                    }
                })
                .catch(response => {
                    //handle error
                    this.base64certificate = null;
                    console.log(response);
                    alert(this.translate('errors.signatureCertCantReceive'));
                    this.setLoading(false);
                });
        },
        signAtToken(item){ // Token üzerinde imzalama yap
            if(this.canceled) {
                item.State = signStatus.canceled;
                this.error = this.translate('errors.processCancelled');
                this.setLoading(false);
                this.$emit('onerror', this.error);
                this.$forceUpdate();
                this.canceled = false;
                return;
            }


            item.State = signStatus.signing;
            this.$forceUpdate();

            var formData = new FormData();
            formData.set('terminal', this.SelectedCert.SlotId);
            formData.set('certificateNumber', this.SelectedCert.CertificateSerialNumber);
            formData.set('password', this.PIN);
            formData.set('responseType', 'Json');
            //formData.set('isContentBase64', true);
            //formData.set('content', item.ContentForSign);
            formData.set('licence', this.oldLicence);

            if(item.SigningFunction == 'cades/signdigest') {
                formData.set('digest', item.ContentForSign);
                formData.append("includeContent", false);
            } else {
                formData.set('content', item.ContentForSign);
                formData.set('isContentBase64', true);

                if(item.SigningFunction != 'mime/signmime')
                formData.append("includeContent", true);
            }

            return axios({
                method: 'post',
                url: `https://imzalayici.imzalayici.com/${item.SigningFunction}`,
                data: formData,
                headers: {'Content-Type': 'multipart/form-data' }
                })
                .then(response => {
                    console.log('SignResponse: ', response);

                    var signedValue = item.SigningFunction == 'mime/signmime' ? response.data : (response.data.signatureValue || response.data.Data)

                    this.postDocument(item, signedValue); // İmzalı dosyayı sunucuya yükle

                    var doc = this.items[++this.currentDocumentIndex];  // Sonraki imzalanacak dosyayı al

                    if(doc)
                    {
                        if(this.canceled)
                            return;

                        this.signDocument(doc); // Sonraki dosya için imzalamayı başlat
                    }

                    console.log('İmzalama başarılı: ', response);
                })
                .catch(response => {
                    //handle error
                    item.OK = false;
                    item.State = signStatus.error;
                    item.ModelState = response.response.data.ModelState;
                    this.signing = false;
                    this.error =  this.translate('errors.fileCantSigned:' + item.FileName) + ':\r\n' + response.response.data.Message;
                    this.$emit('onerror', this.error);
                    this.setLoading(false);
                    this.$forceUpdate();
                    //console.log('İmzalama başarısız: ', response);
                });
        },
        postDocument(item, data) {  // İmzalı dosyayı sunucuya gönder
            if(this.canceled) {
                item.State = signStatus.canceled;
                this.error = this.translate('errors.processCancelled');
                this.$emit('onerror', this.error);
                this.$forceUpdate();
                return;
            }

            if(this.error)
                return;

            if(!item.PostUrl) {
                item.SignedContent  = data;
                item.OK = true;
                item.State = signStatus.completed;
                this.setLoading(false);
                this.$forceUpdate();

                if(this.items.filter(i => !i.OK).length == 0) {
                    this.$emit('completed', this.items);
                }
            } else {
                item.State = signStatus.sending;
                this.$forceUpdate();

                var params = item.PostParams || {};
                params.SignedContentBase64 = data;
                params.CertificateBase64 = this.base64certificate;
                params.SigningTime = item.SigningTime;
                params.TransactionId = item.TransactionId;

                axios.post(item.PostUrl, params).then(x => {
                    if(x.data.Success) {
                        item.OK = true;
                        item.State = signStatus.completed;
                        item.SignedContent  = x.data.Data?.Base64Signature;
                        if(this.items.filter(i => !i.OK).length == 0) {
                            this.$emit('completed', this.items);
                        }
                    } else {
                        item.OK = false;
                        item.State = signStatus.error;
                        this.setLoading(false);
                        item.ModelState = x.data.ModelState;
                        this.error = this.translate('errors.fileCantUploaded:' + item.FileName)
                        this.$emit('onerror', this.error);
                    }
                    this.$forceUpdate();
                }).catch(x => {
                    item.State = signStatus.error;
                    item.OK = false;
                    this.setLoading(false);
                    item.ModelState = x.response.data.ModelState;
                    this.error = this.translate('errors.fileCantUploaded:' + item.FileName)
                    this.$emit('onerror', this.error);
                });
            }
        },
        signDocument(item) {
            // Parametre olarak verilen dosyayı imzala

            if(this.canceled) {
                item.State = signStatus.canceled;
                this.error = this.translate('errors.processCancelled');
                this.$emit('onerror', this.error);
                this.$forceUpdate();
                return;
            }

            if(this.error)
                return;

            this.setLoading(true);



            if(item.ContentForSign) {   // Eğer imzalanacak değer doğrudan item.ContentForSign içinde sağlanmış ise direk onu imzalıyoruz.
                this.signAtToken(item)
            } else {
                // item içinde içerik sağlanmamış ise item.GetUrl adresinden imzalanacak içeriği indiriyoruz.
                item.State = signStatus.prepearing;
                this.$forceUpdate();

                axios.get(item.GetUrl + '&certificateNumber=' + this.SelectedCert.CertificateSerialNumber)      // Dosyayı indir
                    .then(x => {
                        if(x.data.Success) {
                            item.SigningFunction = x.data.Data.SigningFunction;
                            item.SigningTime = x.data.Data.SigningTime;
                            item.TransactionId = x.data.Data.TransactionId;
                            item.ContentForSign = x.data.Data.ContentForSign;
                            this.signAtToken(item); // İmzalamak için tokena gönder
                        } else {
                            this.error = x.data.ErrorMessages;
                            this.setLoading(false);
                        }
                    })
                    .catch(x => {
                        item.OK = false;
                        item.State = signStatus.error;
                        item.ModelState = x.response.data.ModelState;
                        this.error = this.translate('errors.downloadError') + x;
                        this.setLoading(false);
                        this.$emit('onerror', this.error);
                        this.$forceUpdate();
                    });
            }
        },
        sign(){
            // Tüm dosyaları sırayla imzala
            // 1 - Sunucudan veriyi indir
            // 2 - Token üzerinde imzalama gerçekleştir
            // 3 - İmzalanan veriyi sunucuya gönder
            // 4 - Bir sonraki dosya için aynı süreci başlat
            // 4 - Tüm dosyaların imzalanması tamamlandığında dosyaları kabul işlemini çağır
            if(!this.PIN) {
                alert(this.translate('errors.enterESignaturePassword'));
                this.$refs.pin.focus();
                return false;
            }

            if(!this.items || this.items.length == 0) {
                alert(this.translate('errors.noDocumentsToSign'));
                return false;
            }

            this.setLoading(true);
            this.error = null;
            this.canceled = false;
            this.currentDocumentIndex = 0;

            this.items.forEach(x => {
                x.State = null;
                x.OK = false;
                delete x.ModelState;
            });

            var doc = this.items[this.currentDocumentIndex];    // İlk dosyayı al
            this.signDocument(doc); // ve imzalamayı başlat
            return true;
        }
    }
}
</script>

<style scoped>
    .checking {
        color: color('gray-600');
        text-align:center;
        vertical-align: middle;
        height: 500px;
    }

    .terminal {
        padding:8px 10px;
        background-color: #EDEDED;
    }

    .cert-list {
        height:300px;
        overflow-y:auto;
        padding:0;
    }



    #pin {
        text-align: center;
    }

    .item-list {
        background: #FFF;
        border:1px solid #E0E0E0;
        height:200px;
        overflow-y: scroll;
    }
    .spinner-container{
    width: 100%;
    height: 100%;
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    background-color: #a0a0a070;
    }
    .spinner {
        border-radius: 50%;
        width: 24px;
        height: 24px;
        border: 2px solid rgba(0, 0, 0, 0.2);
        border-top-color: #0077ff;
        animation: spin 1s ease-in-out infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
    .downloadButtons{
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: center;
        justify-content: center;
    }
    .downloadButton{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
        width: fit-content;
    }
</style>
